import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

type Result = ModelHookResult<{
	localizedCount: string;
	localizedGoal: string;
	completionPercentage: number;
	countLabel: string;
	countA11yLabel: string;
	goalLabel: string;
	goalA11yLabel: string;
	thermometerAriaLabel: string;
}>;

export function useContributionCount(): Result {
	const {
		data: {
			petition: {
				promotionStats: { promoterCount, promoterCountLocalized },
			},
			promotionGoal,
			promotionGoalLocalized,
		},
	} = usePsfPromoteOrSharePageData();
	const { translate, translatePlural } = useI18n();

	return {
		data: {
			localizedCount: promoterCountLocalized,
			localizedGoal: promotionGoalLocalized,
			completionPercentage: Math.round((promoterCount / promotionGoal) * 100),
			countLabel: translatePlural('corgi.psf.promote_or_share.contributions.count_bar.count', promoterCount),
			countA11yLabel: translate('corgi.psf.promote_or_share.contributions.count_bar.a11y.count', {
				contributionCount: promoterCountLocalized,
			}),
			goalLabel: translate('corgi.psf.promote_or_share.contributions.count_bar.goal'),
			goalA11yLabel: translate('corgi.psf.promote_or_share.contributions.count_bar.a11y.goal', {
				nextGoal: promotionGoalLocalized,
			}),
			thermometerAriaLabel: translate('corgi.psf.promote_or_share.contributions.thermometer.label'),
		},
	};
}
